export const basicFormData = () => ({
  inputData: {
    category_name: "",
    is_active: true,
    created_by: 1,
    updated_by: 1,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "category_masters",
  };

  const navigatePage = { back: "/category-list" };

  const headerName = "Category";

  const validationType = "CategoryCreate";
  const createEndpoint = "/createCategory";
  const updateEndpoint = "/updateCategory";
  const getEndpoint = "/getCategoryById";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "category_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Category Name", value: "category_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/category-create",
    edit: "/category-create",
    view: "/category-view",
  };

  const searchfields = ["category_name", "createdBy.first_name"];

  const headerName = "Category";
  const endpoint = "/listCategory";
  const exportFileName = "categortData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "category_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
